"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var selectDealerButtonStyles_1 = require("./selectDealerButtonStyles");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var DefaultButton_1 = require("../../../../../../common/components/presentation/Buttons/DefaultButton");
var SelectDealerButton = function (_a) {
    var isSelected = _a.isSelected, onClick = _a.onClick, testId = _a.testId, disableDealerSelection = _a.disableDealerSelection;
    var styles = selectDealerButtonStyles_1.default();
    var disableButton = isSelected || !!disableDealerSelection;
    var translationId = isSelected
        ? 'trans__checkout__dealers_page__selected_CTA'
        : 'trans__checkout__dealers_page__select_CTA';
    return (<DefaultButton_1.default disabled={disableButton} onClick={onClick} className={[isSelected && styles.isSelected, styles.buttonLabel]} dataTest={testId} variant="outlined" outlinedPrimary={styles.newOutlinedPrimary}>
      <Translation_1.default id={translationId}/>
    </DefaultButton_1.default>);
};
exports.default = SelectDealerButton;
